import {filter, trigger, lazy} from './lang.js';
import {doc} from './documentation.js';
import Tone from 'tone';
import MidiTrigger from '../MidiTrigger.js';
import {trig} from './trig.js';

doc(
    "harmonize", 
    {
        "...harmonies": "Transposes to harmonize"
    },
    "Harmonizes with the given transposees",
);

export const harmonize = (... harmonies) => {
    return (...args) => {
        let _harmonies = harmonies.flat().map(
            x => lazy(x, ... args)).flat();

        // for each of these arguments create a new trigger
        let [stepData, stepNumber, time, effect] = args;
        if (!stepData) {
            return filter(false);
        }
        let triggers = [];
        let _trigger = new MidiTrigger(stepData, time, stepNumber);
        for (let harmony of _harmonies) {
            let {stepData} = effect.copyTrigger(_trigger, true);
            stepData.transpose += harmony;
            triggers.push({
                stepData, stepNumber, time});
        }
        let x = trigger([{stepData, time, stepNumber}, ... triggers]);
        return x;
    };
};
doc(
    "strum", 
    {
        "spread": "Number from 1-10"
    },
    "Spreads out triggers on same step, so they strum",
);


export const strum = (spread=1) => {
    let currentStepNumber = undefined;
    let i=0;
    let isLive = undefined;
    return (... args) => {
        let [stepData, stepNumber, time] = args;
        if (!time && !isLive) {
            isLive = Tone.Master.context.currentTime + 0.05;
            i=1;
            currentStepNumber = stepNumber;
            return filter(true);
        } else if (!stepData || currentStepNumber !== stepNumber) {
            i=1;
            currentStepNumber = stepNumber;
            isLive = undefined;
            return filter(true);
        }

        if (!time && isLive) {
            time = isLive;
        }
        currentStepNumber = stepNumber;
        let _spread = lazy(spread, ...args);
        let delayedTrigger = {stepData, stepNumber, time: time + i*_spread*0.01};
        i++;
        return trigger(delayedTrigger);
    };
}
